import { get } from 'common';

const EVENTS_ROUTE = `${process.env.REACT_APP_API_CONFIG}events`;

export class EventsService {
    private static instance: EventsService;

    static getInstance(): EventsService {
        if (!this.instance) {
            this.instance = new EventsService();
        }

        return this.instance;
    }

    async findAll() {
        return await get(`${EVENTS_ROUTE}/`);
    }

    async findOne(id: number) {
        return await get(`${EVENTS_ROUTE}/${id}`);
    }
}
